import React from "react";
import PropTypes from "prop-types";

function DefaultAuthor() {
  return (
    <svg width='152' height='152' xmlns='http://www.w3.org/2000/svg'>
    <path d='M118.2 138a42.3 42.3 0 0 0-42-40 42.3 42.3 0 0 0-42 40.3 74.7 74.7 0 0 0 84-.3zm-44-45.2A23.1 23.1 0 0 0 97 69.4C97 56.4 86.8 46 74.2 46a23.1 23.1 0 0 0-22.8 23.4c0 13 10.2 23.4 22.8 23.4zM76 152A76 76 0 1 1 76 0a76 76 0 0 1 0 152z'
    fill='#DADEE1' fillRule='evenodd' />
</svg>
  );
}

DefaultAuthor.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

export { DefaultAuthor };
